import { memo, ReactElement, useState } from 'react';
import { Box, Flex } from 'reflexbox';
import { Label, SearchInput } from '../../styles';
import SelectSearch, { fuzzySearch } from 'react-select-search';

interface SelectDevTypeProps {
  defaultDev: string;
  onFilterDevChange: (devType: string) => void;
  onDutVersionChange?: (version: string) => void;
}

const devTypesList = [
  { value: 'DAM', name: 'Ar Condicionado Centrais Fixas' },
  { value: 'DUT', name: 'Ar Condicionado Split' },
  { value: 'Iluminação', name: 'Iluminação' },
  { value: 'Splitão Inverter', name: 'Splitão Inverter' },
  { value: 'Fancoil e VAV', name: 'Fancoil e VAV' },
];

const dutVersionsList = [
  { value: 'DUT3', name: 'DUT3' },
  { value: 'DUT4', name: 'DUT4' },
];

export const SelectDevType = memo(({ defaultDev, onFilterDevChange, onDutVersionChange }: SelectDevTypeProps): ReactElement => {
  const [selectedDevType, setSelectedDevType] = useState<string>(defaultDev ?? '');
  const [dutVersion, setDutVersion] = useState<string>('DUT3');

  function onChangeDevType(devType): void {
    setSelectedDevType(devType);
    onFilterDevChange(devType as string);
    if (devType !== 'DUT') {
      setDutVersion('DUT3');
    } else {
      onDutVersionChange?.('DUT3');
    }
  }

  function onChangeDutVersion(version): void {
    setDutVersion(version as string);
    onDutVersionChange?.(version as string);
  }

  return (
    <Flex flexDirection="row" flexWrap="wrap" style={{ gap: '16px' }}>
      <Box width={[1, 1, 1, 1, 1, 1 / 5]}>
        <SearchInput>
          <div style={{ width: '100%', paddingTop: 3 }}>
            <Label>Tipo de Dispositivo</Label>
            <SelectSearch
              options={devTypesList}
              value={selectedDevType}
              printOptions="on-focus"
              search
              filterOptions={fuzzySearch}
              placeholder="Selecione o tipo de dispositivo"
              onChange={onChangeDevType}
            />
          </div>
        </SearchInput>
      </Box>
      {selectedDevType === 'DUT' && (
        <Box width={[1, 1, 1, 1, 1, 1 / 5]}>
          <SearchInput>
            <div style={{ width: '100%', paddingTop: 3 }}>
              <Label>Versão</Label>
              <SelectSearch
                options={dutVersionsList}
                value={dutVersion}
                printOptions="on-focus"
                search
                filterOptions={fuzzySearch}
                placeholder="Selecione a versão"
                onChange={onChangeDutVersion}
              />
            </div>
          </SearchInput>
        </Box>
      )}
    </Flex>
  );
});
